import { Link } from "react-router-dom";
import { PURPOSE_PARAGRAPHS } from "../data/company-content";
import { CompanyTabs } from "../components/CompanyTabs";
import SEO from "@/components/SEO";

export default function CompanyPurpose() {
  const lastIndex = PURPOSE_PARAGRAPHS.length - 1;

  return (
    <>
      <SEO
        title="Our Purpose | Motosport Software"
        description="Learn the mission behind Motosport Software and how we simplify buying, selling, and moving vehicles through a unified workflow."
        url="https://motosportsoftware.com/company/purpose"
      />
      <main className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <CompanyTabs currentTab="purpose" />
        <div className="mt-6">
          <h2 className="mb-4 text-[30px] font-[800] leading-[36px] tracking-tight text-[#1F2A3A]">
            Our Purpose
          </h2>
          {PURPOSE_PARAGRAPHS.map((paragraph, index) => {
            if (index === lastIndex) {
              return (
                <p
                  key={index}
                  className="mt-4 text-[17px] font-[800] leading-[25px] text-[#1F2A3A]"
                >
                  {paragraph}
                </p>
              );
            }
            return (
              <p key={index} className="mb-3.5 text-[15px] leading-[24px] text-[#525A68]">
                {paragraph}
              </p>
            );
          })}
        </div>
      </main>
    </>
  );
}
